(ns app.domain.execution.model
  (:require [app.domain.group.model :as group-model]))

(defn workspace [execution]
  (-> execution :entity/parent))


(defn feature? [execution feature]
  (contains? (:execution/features execution) feature))


(defmethod group-model/get-authority-group :entity.type/execution
  [execution]
  (-> execution :entity/parent group-model/get-authority-group))


(def case-states [:execution.state/new-code-enforcement
                  :execution.state/closed-code-enforcement
                  :execution.state/active-code-enforcement])


(def work-order-states [:execution.state/submitted-work-order
                        :execution.state/in-progress-work-order
                        :execution.state/completed-work-order
                        :execution.state/blocked-work-order
                        :execution.state/cancelled-work-order])


(def case-and-work-order-states
  (concat case-states work-order-states))


(def execution-states
  [:execution.state/permit-issued
   :execution.state/construction-started
   :execution.state/occupied
   :execution.state/finished
   :execution.state/construction-stopped
   :execution.state/dormancy
   :execution.state/revoked
   :execution.state/approved
   :execution.state/approved-in-principle
   :execution.state/lapsed
   :execution.state/new-code-enforcement
   :execution.state/closed-code-enforcement
   :execution.state/active-code-enforcement
   :execution.state/active
   :execution.state/closed
   :execution.state/archived
   :execution.state/control
   :execution.state/inspections-started
   :execution.state/complete
   :execution.state/past-due
   :execution.state/payment-due
   :execution.state/to-be-scheduled
   :execution.state/submitted-work-order
   :execution.state/in-progress-work-order
   :execution.state/completed-work-order
   :execution.state/blocked-work-order
   :execution.state/cancelled-work-order])
